import api from './api'

async function getAltasBajas (queryString) {
  const url = queryString
    ? `/reports/altas-y-bajas?${queryString}`
    : '/reports/altas-y-bajas'
  const result = await api.get(url)
  return result.data
}

async function getAltasBajasPdf (queryString) {
  const url = queryString
    ? `/reports/altas-y-bajas/pdf?${queryString}`
    : '/reports/altas-y-bajas/pdf'
  return api.get(url, { responseType: 'blob' })
}

export { getAltasBajas, getAltasBajasPdf }
